import { GatheringPublicFullBodyItem } from "../types";

const gatheringPublicFullBodyGetItemType = (item: GatheringPublicFullBodyItem) => {
	return item.variant;
};
export default gatheringPublicFullBodyGetItemType;
